import { IKey, IKeySideLogoSize } from "../../../../../store/keysTypes";
import getKeyImage from "../../../../../tools/getGetKeyImage";

type ContainerConfig = {
  width: number;
  height: number;
  left: number;
  top: number;
};

const containerConfigs: Record<
  string,
  { front: ContainerConfig; back: ContainerConfig }
> = {
  "fa-head": {
    front: { width: 188, height: 120, left: 101, top: 117 },
    back: { width: 188, height: 120, left: 114, top: 117 },
  },
  flafa: {
    front: { width: 188, height: 120, left: 101, top: 117 },
    back: { width: 188, height: 120, left: 100, top: 117 },
  },
  "ov-head": {
    front: { width: 188, height: 100, left: 105, top: 134 },
    back: { width: 188, height: 100, left: 109, top: 134 },
  },
};

const originalContainerConfigs: Record<
  string,
  { front: ContainerConfig; back: ContainerConfig }
> = {
  "abu-17d": {
    front: { width: 264, height: 140, left: 65, top: 172 },
    back: { width: 264, height: 140, left: 70, top: 172 },
  },
  "abu-86d": {
    front: { width: 212, height: 110, left: 96, top: 144 },
    back: { width: 212, height: 110, left: 92, top: 144 },
  },
  "abu-93": {
    front: { width: 250, height: 140, left: 74, top: 200 },
    back: { width: 250, height: 140, left: 74, top: 200 },
  },
  "bk-7d": {
    front: { width: 184, height: 140, left: 110, top: 108 },
    back: { width: 184, height: 140, left: 106, top: 108 },
  },
  "bur-23": {
    front: { width: 250, height: 100, left: 74, top: 150 },
    back: { width: 250, height: 100, left: 74, top: 150 },
  },
  "ce-53d": {
    front: { width: 244, height: 80, left: 78, top: 168 },
    back: { width: 244, height: 80, left: 78, top: 168 },
  },
  "dom-21": {
    front: { width: 250, height: 100, left: 74, top: 130 },
    back: { width: 250, height: 100, left: 74, top: 130 },
  },
  "haf-2d": {
    front: { width: 250, height: 150, left: 74, top: 194 },
    back: { width: 250, height: 150, left: 74, top: 194 },
  },
  "is-15": {
    front: { width: 250, height: 140, left: 74, top: 190 },
    back: { width: 250, height: 140, left: 74, top: 190 },
  },
  "jng-1d": {
    front: { width: 250, height: 100, left: 74, top: 150 },
    back: { width: 250, height: 100, left: 74, top: 150 },
  },
  "re-6d": {
    front: { width: 250, height: 130, left: 74, top: 214 },
    back: { width: 250, height: 130, left: 74, top: 214 },
  },
  "u-15d": {
    front: { width: 250, height: 130, left: 74, top: 194 },
    back: { width: 250, height: 130, left: 74, top: 194 },
  },
  "wil-66d": {
    front: { width: 232, height: 80, left: 88, top: 160 },
    back: { width: 232, height: 80, left: 80, top: 160 },
  },
  "win-22": {
    front: { width: 250, height: 120, left: 70, top: 140 },
    back: { width: 250, height: 120, left: 78, top: 140 },
  },
};

const keyHeights: Record<string, number> = {
  "fa-head": 266,
  "ov-head": 270,
  flafa: 330,
};

const keyHeightOriginal: Record<string, number> = {
  "abu-17d": 335,
  "abu-86d": 335,
  "abu-93": 396,
  "bk-7d": 335,
  "bur-23": 396,
  "ce-53d": 335,
  "dom-21": 396,
  "haf-2d": 396,
  "is-15": 396,
  "jng-1d": 396,
  "re-6d": 396,
  "u-15d": 396,
  "wil-66d": 335,
  "win-22": 335,
};

export const KeyImage = (props: { _key: IKey; side: string; profile: any }) => {
  const { _key, side, profile } = props;

  const src = getKeyImage({
    profile,
    blank: _key.blank,
    side,
    customization: "configuration",
  });

  const keySide = _key[side.toLowerCase() as "front" | "back"];
  const isOriginal = _key.blank === "original-head";
  const isFLA = profile === "flafa";
  const container = isOriginal
    ? originalContainerConfigs?.[_key.value]?.[side as "front" | "back"] ??
      containerConfigs["fa-head"][side as "front" | "back"]
    : isFLA
    ? containerConfigs["flafa"][side as "front" | "back"]
    : containerConfigs[_key.blank][side as "front" | "back"];

  const keyHeight = isOriginal
    ? keyHeightOriginal[_key.value]
    : isFLA
    ? 260
    : keyHeights[_key.blank] ?? 270;

  return (
    <div style={{ width: "400px" }}>
      <span>{String(profile).toLocaleUpperCase()}</span>
      <div
        style={{
          position: "relative",
          backgroundSize: "100%",
          height: `${keyHeight}px`,
          overflow: "hidden",
        }}
      >
        <img
          style={{
            position: "absolute",
            width: "100%",
          }}
          src={src.image}
        />
        <div
          style={{
            position: "absolute",
            width: `${container.width}px`,
            height: `${container.height}px`,
            left: `${container.left}px`,
            top: `${container.top}px`,
            // border: "1px solid red",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {keySide.logo ? (
            <img
              src={keySide.logo}
              style={{
                objectFit: "contain",
                height: "100%",
                margin: "0 auto",
                transform: `scale(${
                  keySide.logoSize === IKeySideLogoSize.BIG
                    ? 1
                    : keySide.logoSize === IKeySideLogoSize.MEDIUM
                    ? 0.7
                    : 0.5
                })`,
              }}
            />
          ) : (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {keySide.text.map((text, index) => (
                <div
                  key={index}
                  style={{
                    fontSize: `${keySide.size[text.name]}px`,
                    fontFamily: keySide.font,
                    color: "white",
                    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
                    margin: "2px 0",
                    textAlign: "center",
                  }}
                >
                  <span
                    style={{
                      width: 0,
                      overflow: "hidden",
                      display: "inline-block",
                    }}
                  >
                    I
                  </span>
                  {text.value}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
